import styled from 'styled-components';

export const TopicListContainer = styled.section<{ $open: boolean }>`
  max-height: 100%;
  transition: max-height 1s ease;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  padding-bottom: ${({ $open }) => ($open ? '19px' : '0px')};

  &:last-child {
    border: none;
  }
`;

export const TopicListHeader = styled.div`
  cursor: pointer;
  display: flex;
  padding: 1.2666rem 2rem 1.2666rem 2rem;
  align-items: center;
`;

export const Toggle = styled.label`
  padding-right: 10px;
  cursor: pointer;
  width: 100%;
  > input {
    display: none;
  }

  display: flex;
  align-items: center;
`;

export const ToggleTopic = styled.label`
  display: flex;
  flex-direction: row;
  padding-right: 10px;
  cursor: pointer;
  align-items: center;
`;

export const CheckBoxContainer = styled.div`
  flex-grow: 1;
  margin-right: 10px;
`;

export const CaretContainer = styled.div`
  flex-grow: 1;
`;

export const TopicName = styled.span`
  font-size: 1rem;
  letter-spacing: 0.2px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a8};
`;

export const QuestionContainer = styled.div`
  display: flex;
  padding-left: 3.666rem;
  align-items: center;
`;

export const AllQuestionsContainer = styled.span<{ $show: boolean }>`
  display: ${({ $show }) => ($show ? 'inline' : 'none')};
`;

export const EditCustomQuestion = styled.div`
  width: 100%;
  padding: 0 30px 0 55px;
`;

export const IconMargin = styled.div`
  margin-left: 5px;
  flex: 1;
  margin-right: 16px;
`;

export const PenIcon = styled.div`
  opacity: 0;
  width: initial;
  &:hover {
    opacity: 1 !important;
  }
`;

export const QuestionText = styled.span`
  margin-left: 5px;
  font-size: 1rem;
  line-height: 2.17;
  letter-spacing: 0.3px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a8};
  align-self: center;
  width: 100%;
  &:hover {
    ${PenIcon} {
      opacity: 0.6;
    }
  }
`;

export const InnerAddWrapper = styled.div<{ $empty?: boolean }>`
  padding: ${({ $empty }) => ($empty ? '0' : '1rem')} 1rem 0 3rem;
  overflow: hidden;
  width: 100%;
`;
